import { call, put, race, take, takeLatest, delay } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, CLEAR, fetchSuccess, fetchFailure } from '../../actions/datasources/datasetImport';
import config from '../../../config';
import { getLocalUser } from '../../../utils/localUser';
import { Error as ErrorAction } from '../../actions/error/error';

const TERMINAL = ['completed', 'failed', 'cancelled', 'skipped'];

// Start a multi-file dataset import, then poll GET /datasets/<id> until the
// batch reaches a terminal state. The slice's response holds the live batch
// payload the progress view renders.
function* operation(action) {
  const { datasetId, plan } = action.payload;
  try {
    const res = yield call(
      axios.post,
      `${config.API_URL}/ingestion/connect/datasets/import`,
      { dataset_id: datasetId, plan },
      { headers: getLocalUser() },
    );
    const data = res.data?.data || res.data;
    yield put(fetchSuccess({
      dataset_id: datasetId,
      status: 'importing',
      files: data.executions.map((e) => ({ ...e, status: 'queued' })),
      skipped: data.skipped,
    }));
  } catch (error) {
    yield put(ErrorAction(error));
    yield put(fetchFailure(error.response?.data?.error || error.message || 'Import failed to start.'));
    return;
  }

  while (true) {
    try {
      const res = yield call(
        axios.get,
        `${config.API_URL}/ingestion/connect/datasets/${datasetId}`,
        { headers: getLocalUser() },
      );
      const data = res.data?.data || res.data;
      yield put(fetchSuccess(data));
      if (TERMINAL.includes(data.status) || data.status === 'completed_with_errors') return;
      yield delay(2000);
    } catch (e) {
      yield delay(4000);
    }
  }
}

// CLEAR aborts the polling loop (mirrors the component's unmount cleanup).
function* run(action) {
  yield race([call(operation, action), take(CLEAR)]);
}

export function* watch() {
  yield takeLatest(REQUEST, run);
}
